import { AxAsset } from '@crimsontide/core/client/interfaces';
import DotNetObject = DotNet.DotNetObject;

let dotNetObj: DotNetObject;
let cachedAssets: AxAsset[];

export const AxAssetService = (() => {
  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getAxAssets = async (useCache: boolean = true): Promise<AxAsset[]> => {
    if (useCache && cachedAssets != null)
      return cachedAssets;

    if (dotNetObj) {
      cachedAssets = await dotNetObj.invokeMethodAsync<AxAsset[]>('GetAxAssetByWebUserAsync');
      return cachedAssets;
    } else {
      throw 'AxAsset DotNet Object Reference has not yet been implemented';
    }
  };

  const getAxAssetsByCustomerSite = async (siteId: string, customerId?: string): Promise<AxAsset[]> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<AxAsset[]>('GetAxAssetByCustomerSiteWebUserAsync', customerId, siteId);
    } else {
      throw 'AxAsset DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getAxAssets,
    getAxAssetsByCustomerSite,
  };
})();
